import { type ComponentProps, memo, useMemo } from 'react';

import { cn } from '@air/utils-tailwind';

import { usePlayerStore } from './PlayerContextProvider';

export type PlayerSeekbarTrackProps = Pick<ComponentProps<'div'>, 'className'>;

export const PlayerSeekbarTrack = memo(({ className }: PlayerSeekbarTrackProps) => {
  const currentTime = usePlayerStore((state) => state.currentTime);
  const duration = usePlayerStore((state) => state.duration);

  const progress = useMemo(() => {
    const percentage = (currentTime / duration) * 100;

    if (Number.isNaN(percentage)) {
      return 0;
    }

    return currentTime >= duration ? 100 : percentage;
  }, [currentTime, duration]);

  return (
    <div className={cn('relative w-full', className)} data-progress={progress} data-testid="PLAYER_SEEKBAR_TRACK">
      <div className="h-1 overflow-hidden rounded-4 bg-grey-7">
        <div className="size-full rounded-4 bg-blue-9" style={{ transform: `translateX(-${100 - progress}%)` }} />
      </div>
    </div>
  );
});

PlayerSeekbarTrack.displayName = 'PlayerSeekbarTrack';
